<div class="heading">
    <p><span *ngIf="dialogData">Edit</span><span *ngIf="!dialogData">Add</span> Model</p>
</div>
<form [formGroup]="modelFormgroup">
    <div class="add-model-container">
        <div class="input-container">
            <label for="modelname">Model Name <span class="required">*</span></label>
            <input type="text" id="modelname" formControlName="name" autocomplete="off"/>
            <div *ngIf="formSubmitted && modelFormgroup.get('name')?.invalid" class="error-message">
                Model Name is required.
            </div>
        </div>
        <div class="input-container">
            <label for="cloudmodel">Cloud Model <span class="required">*</span></label>
            <div class="select-container">
                <select id="cloudmodel" formControlName="cloud_model" class="dropdown">
                    <option *ngFor="let cloudModel of cloudModels" [value]="cloudModel.model">{{cloudModel.model}}</option>
                </select>
            </div>
            <div *ngIf="formSubmitted && modelFormgroup.get('cloud_model')?.invalid" class="error-message">
                Cloud Model is required.
            </div>
        </div>
        <div class="input-container">
            <label for="modelvalue">Model Value/ID <span class="required">*</span></label>
            <input type="text" id="modelvalue" formControlName="value" autocomplete="off"/>
            <div *ngIf="formSubmitted && modelFormgroup.get('value')?.invalid" class="error-message">
                Model Value/ID is required.
            </div>
        </div>
        <mat-divider></mat-divider>
        <div class="d-flex par-cof-model-info">
            <h4 class="m-0">Parameter Configuration</h4>
            <p class="m-0" style="color: #503291; border-bottom: 1px solid #503291; cursor: pointer;" (click)="viewModelInfo()" *ngIf="modelFormgroup.get('cloud_model')?.value">View Model Info</p>
        </div>

        <div class="mb-16">
            <div class="par-conf-container">
                <div class="input-container mr-16" style="margin-bottom: 0;">
                    <label for="parname">Parameter Name</label>
                    <input type="text" placeholder="Enter Name" id="parname" [(ngModel)]="parameterName" (input)="onInputParName($event)" [ngModelOptions]="{standalone: true}"/>
                </div>
                <div class="input-container mr-16" style="margin-bottom: 0;">
                    <label for="parvalue">Parameter Value</label>
                    <input type="text" placeholder="Enter Value" id="parvalue" [(ngModel)]="parameterValue" (input)="onInputParValue($event)" [ngModelOptions]="{standalone: true}"/>
                </div>
                <div class="mt-4">
                    <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Add'" [iconSrc]="'/assets/icons/Plus_button.svg'" (click)="addParameter()"></app-button>
                </div>
            </div>
            <div *ngIf="!(parameterName && parameterValue) && isParValName" style="color: red;">Please enter valid parameter key and value</div>
        </div>
        <div style="max-height: 132px; height: 100%; overflow: auto; border: 1px solid #ECECF4; border-radius: 4px;">
           

            <div *ngFor="let element of configurationArray" class="table-row-container">
                <div class="table-row">
                    <!-- Key column -->
                    <div class="table-cell">
                        <ng-container *ngIf="!element.isEditing">
                            {{element.key}}
                        </ng-container>
                        <ng-container  *ngIf="element.isEditing">
                            <input [(ngModel)]="element.key" (input)="onInputEleKey(element)" [ngModelOptions]="{standalone: true}"/>
                        </ng-container>
                    </div>
            
                    <!-- Value column -->
                    <div class="table-cell">
                        <ng-container *ngIf="!element.isEditing">
                            {{element.value}}
                        </ng-container>
                        <ng-container *ngIf="element.isEditing">
                            <input [(ngModel)]="element.value" (input)="onInputEleValue(element)" [ngModelOptions]="{standalone: true}"/>
                        </ng-container>
                    </div>
            
                    <!-- Actions column -->
                    <div class="table-cell">
                        <div class="d-flex justify-content-end">
                            <img *ngIf="!element.isEditing" src="/assets/admin-images/pen_icon.png" alt="edit" class="mr-16 cursor-pointer" style="height: 24px;" (click)="editRow(element)" />
                            <img *ngIf="!element.isEditing" src="/assets/admin-images/bin_icon.png" alt="delete" style="height: 24px;" class="mr-6 cursor-pointer" (click)="deleteRow(element)" />
                            <div class="d-flex" style="padding: 6px;" *ngIf="element.isEditing">
                                <img src="/assets/admin-images/cancel.png" alt="" class="mr-8 cursor-pointer" style="height: 24px;" (click)="closeRow(element)">
                                <img src="/assets/admin-images/check_circle.png" alt="" class="cursor-pointer" style="height: 24px;" (click)="saveRow(element)">
                            </div>
                        </div>
                    </div>
                </div>
                
               
                <div *ngIf="!saveEditing && (element.key === undefined || element.key === null || element.key === '' || element.value === undefined || element.value === null || element.value === '')" style="color: red;">Please enter parameter key and value</div>
                <div *ngIf="element.isEditing && saveEditing" style="color: red;">Please save or cancel the parameters updation</div>
            </div>
        </div>


    </div>
    <div class="footer-section">
        <div class="footer-btn-section">
            <app-button [type]="'secondary'" [buttonType]="'button'" [buttonText]="'Cancel'" [iconSrc]="'/assets/admin-images/cancel_icon.svg'" (click)="cancelModel()" class="mr-16"></app-button>
            <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Add'" [iconSrc]="'/assets/icons/Plus_button.svg'" (click)="submitModel()" *ngIf="!dialogData"></app-button>
            <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Update'" [iconSrc]="'/assets/admin-images/cached.svg'" (click)="updateModel()" *ngIf="dialogData?.isUpdateModel"></app-button>
        </div>
    </div>
</form>